"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5.838 8.542L2.66 5.364l3.899-.72 3.703-3.091.233-1.082 3.46 3.46-1.12.195L9.756 7.84l-.732 3.887zm1.569 1.602l-6.911 3.89L4.359 7.18z",
    fill: "none",
    stroke: "#919499"
  }));
}

var MemoSvgPin = /*#__PURE__*/React.memo(SvgPin);
var _default = MemoSvgPin;
exports["default"] = _default;